module.exports = __webpack_public_path__ + "static/save-webhook-f50cd257978e632358ab0642d0f9f6f4.png";